import { render } from "./AppFooter.vue?vue&type=template&id=e0729ddc&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=e0729ddc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0729ddc"]])

export default __exports__